// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2B3Iv","inner":"Footer_inner__34Kyd"};